import React, { useContext } from 'react'
import { Dropdown } from 'react-bootstrap'
import { LANGUAGE_CODES } from '../../../constants/languageList'
import CustomDropdownToggle from '../../custom/CustomDropdownToggle'
import Icon from 'icons/Icon'

const LanguageField = ({ formik, contextValue, disabled = false }) => {
  const { languages, languageData, tenantDetails, generalConfig } = useContext(contextValue)
  const { values, setFieldValue, validateField, errors, touched } = formik
  const hasError = errors?.preferredLanguage && touched?.preferredLanguage
  return (
    <Dropdown
      className={`preferred-language icon-right small-height ${disabled ? 'pe-none' : ''}`}
      id='preferredLanguage'
    >
      <Dropdown.Toggle id='dropdown-basic2' as={CustomDropdownToggle} hasError={hasError}>
        <span>
          {LANGUAGE_CODES?.[values?.preferredLanguage] ||
            languageData?.selectPreferredLanguage}
        </span>
        <Icon name='drop-arrow' className='drop-arrow-icon' />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <div className='scrollDropdown'>
          <Dropdown.Item disabled>
            {languageData?.selectPreferredLanguage}
          </Dropdown.Item>
          {languages?.allowedLanguages?.map((lang) => (
            <Dropdown.Item
              key={lang}
              onClick={async () => {
                await setFieldValue('preferredLanguage', lang)
                validateField('preferredLanguage')
                const langCurrency = generalConfig?.defaultCurrencyByLanguage?.[lang?.toUpperCase()]
                const matchingCurrencies = tenantDetails?.tenantConfig?.matchingCurrencies
                if (langCurrency && (!matchingCurrencies || matchingCurrencies.includes(langCurrency))) {
                  await setFieldValue('currencyCode', langCurrency)
                  validateField('currencyCode')
                }
              }}
            >
              {LANGUAGE_CODES[lang]}
            </Dropdown.Item>
          ))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default LanguageField
